module.exports = __webpack_public_path__ + "img/facebook.f5931067.svg";